// Keep tenant transitions in one place so newly added domain reducers also reset.
const tenantIdentity = auth => auth?.user?.salon_id != null
  ? String(auth.user.salon_id)
  : auth?.token || null;

export const withTenantReset = combinedReducer => {
  const requests = new Map();
  let generation = 0;
  return (state, action) => {
    if (!state) requests.clear();
    const owner = tenantIdentity(state?.auth);
    const requestId = action.meta?.requestId;
    if (requestId && action.type.endsWith('/pending')) requests.set(requestId, generation);
    if (requestId && /\/(fulfilled|rejected)$/.test(action.type) && requests.has(requestId)) {
      const requestGeneration = requests.get(requestId);
      requests.delete(requestId);
      if (requestGeneration !== generation) return state;
    }
    // Persistence may finish after a handoff. Complete registration without
    // merging auth or domain values saved before this tenant transition.
    const safeAction = generation > 0 && action.type === "persist/REHYDRATE"
      ? { ...action, payload: undefined }
      : action;
    const next = combinedReducer(state, safeAction);
    const loggedOut = action.type === 'auth/authlogout' || action.type === 'auth/logout/fulfilled';
    if (!state || (!loggedOut && owner === tenantIdentity(next.auth))) return next;

    generation += 1;
    const initial = combinedReducer(undefined, { type: '@@tenant/reset' });
    for (const key of Object.keys(initial)) {
      if (key === 'auth') continue;
      // Preserve redux-persist's registration; only the domain values reset.
      if (state[key]?._persist) initial[key] = { ...initial[key], _persist: state[key]._persist };
    }
    return { ...initial, auth: next.auth };
  };
};
